/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "64a61371cf508c220e34cd0110fe0f18584baeac";
